import type { FC } from 'react';

import { CheckBox } from '@interstate/components/CheckBox';
import { Box } from '@interstate/components/Box';

import type { CellFinanceDetailsProps } from './types';

export const TaxedCell: FC<CellFinanceDetailsProps> = ({ detail, index }) => {
    return (
        <Box data-testid="edit-fee--taxed-cell" display="flex" alignItems="center">
            <CheckBox
                sx={{
                    backgroundColor: 'inherit'
                }}
                name="isTaxed"
                checked={Boolean(detail.isTaxed)}
                label="Taxed"
                value={`${detail.isTaxed}-${index}`}
                data-testid={`edit-fee--taxed-cell-${index}`}
                disabled={true}
            />
        </Box>
    );
};
